import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MyStreamWaveMyVotesResetProgressProps {
  readonly isResetting: boolean;
  readonly resetProgress: number;
  readonly totalCount: number;
}
const MyStreamWaveMyVotesResetProgress: React.FC<MyStreamWaveMyVotesResetProgressProps> = t0 => {
  const $ = _c(9);
  const {
    isResetting,
    resetProgress,
    totalCount
  } = t0;
  if (!isResetting) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Resetting votes...</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== resetProgress || $[2] !== totalCount) {
    t2 = <div className="tw-flex tw-items-center tw-justify-between tw-mb-1 tw-text-xs tw-text-iron-400">{t1}<span className="tw-font-medium">{resetProgress} / {totalCount}</span></div>;
    $[1] = resetProgress;
    $[2] = totalCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${resetProgress / totalCount * 100}%`;
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-h-1 tw-w-full tw-bg-iron-800 tw-rounded-full tw-overflow-hidden"><div className="tw-h-full tw-bg-primary-500 tw-rounded-full tw-transition-all tw-duration-200 tw-ease-out" style={{
        width: t3
      }} /></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="tw-mt-3 tw-px-0.5">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default MyStreamWaveMyVotesResetProgress;